import React, { useEffect, useState } from 'react';
import {Grid, Box, Modal, Typography, Checkbox, Button, LinearProgress, TextField} from "@mui/material";
import { styles } from "./styles";
import CloseIcon from '@mui/icons-material/Close';
import MuiSelect from "components/MuiSelect/MuiSelect";
import {
  addDevice,
  getAllDeviceTypes,
  getAllServiceProviders,
  getAllTrucks,
  editDevice,
  getSegment,
  addTruck,
  getTruckDetails,
  editTruck,
  getWareHouses,
  getAllDevices,
  getTruckAllTypes,
  getTruckAllServiceTypes,
  getTruckAllFuelTypes, getAvailableDevices, deviceDisassoc, deleteTruck, deleteDevice
} from 'apis/device';
import { getAllRoles } from 'apis/user';
import { Colors } from 'assets/colors';
import DeleteTruckModal from "./DeleteTruckModal";
import DisassociateTruckModal from "./DisassociateTruckModal";
import TruckMuiSelect from "../MuiSelect/TruckMuiSelect";
import CommonUtil from "../../common/CommonUtil";
import ToastManager from "../../common/ToastManager";
import DeleteModal from "../../common/DeleteModal";
import DisAssocModal from "../../common/DisAssocModal";

interface InputType {
  type: string,
  placeholder: string,
  disabled?: boolean,
  label?: string,
  size: number,
  key: string,
  onChange: any,
  value: string,
  required?:boolean,
  error?:boolean
}

interface SelectType {
  size: number
}

interface DeviceModalProps {
  open: boolean;
  handleClose: Function | any;
  getTruckList: Function;
  truckToEdit?: any;
}
let defaultTruck = {
  "truckName": "",
  "truckStatus": "Active",
  "truckType": "",
  "warehouseLocation":"",
  "warehouseLocationId":"",
  "timeZone": "",
  "size":"",
  "serviceType": "",
  "serviceTypeId": "",
  "serviceProvider": "",
  "serviceProviderId": "",
  "segmentId": "",
  "segment": "",
  "iotDeviceId": "",
  "fuelType": "",
  "chassisModel": "",
  "chassisMake": "",
  "bodyModel": "",
  "bodyMake": "",
  "configDevices":"",
  "deviceName":""
}

let flag:boolean = false;
let truckData:any = null;
let changeServiceProvider = false;
let trcukDetails:any = null;

let deviceId:string = "";
let deviceName:string = "";
let truckId:string = "";
const TruckModal: React.FC<DeviceModalProps> = ({ open, handleClose, getTruckList, truckToEdit }) => {

  const [truck, setTruck] = useState(defaultTruck);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [types, setTypes] = useState<any>([]);
  const [serviceTypes, setServiceTypes] = useState<any>([]);
  const [fuelTypes, setFuelTypes] = useState<any>([]);
  const [applications, setApplications] = useState([]);
  const [trucks, setTrucks] = useState<any>([]);
  const [devices, setDevices] = useState<any>([]);
  const [truckOptions, setTruckOptions] = useState([]);
  const [currentTruckName, setCurrentTruckName] = useState("");


  const [providers, setProviders] = useState<any>([]);
  const [segments, setSegments] = useState<any>([]);
  const [warehouses, setWarehouses] = useState<any>([]);
  const [segmentError, setSegmentError] = useState('');

  const [currentDevice,setSelectedDevice] = useState<any>(null);
  const [deviceDisassociation,setDeviceDisassociation] = useState(false);
  const [truckStatuses,setTruckStatuses] = useState<any>(CommonUtil.trcukStatuses);

  const [trackId,setTrackId] = useState("");
  const [trackIdErr,setTrackIdErr] = useState(true);

  const [status,setStatus] = useState<any>({key:'Active',value:'Active'});
  const [statusError,setStatusError] = useState(false);

  const [truckType,setTruckType] = useState<any>(null);
  const [truckTypeError,setTruckTypeError] = useState(true);

  const [serviceType,setServiceType] = useState<any>(null);
  const [serviceTypeError,setServiceTypeError] = useState(true);

  const [currentServiceProvider, setCurrentServiceProvider] = useState<any>(null);
  const [currentServiceProviderError, setCurrentServiceProviderError] = useState(true);

  const [currentSegment, setCurrentSegment] = useState<any>(null);
  const [currentSegmentError, setCurrentSegmentError] = useState(true);

  const [currentWarehouse, setCurrentWareHouse] = useState<any>(null);
  const [currentWarehouseError, setCurrentWareHouseError] = useState(true);

  const [timeZones, setTimeZones] = useState<any>(CommonUtil.timeZones);
  const [timeZone, setTimeZone] = useState<any>(null);
  const [timeZoneErr,setTimeZoneErr] = useState(true);


  const [truckBodyModel,setTruckBodyModel] = useState("");
  const [truckBodyMake,setTruckBodyMake] = useState("");
  const [chasisMake,setChasisMake] = useState("");
  const [chasisModel,setChasisModel] = useState("");
  const [truckSize,setTruckSize] = useState("");

  const [fuelType,setFuelType] = useState<any>(null);
  const [page,setPage] = useState(0);

  const [delDevice,setDelDevice] = useState(false);
  const [disassocDevice,setDisassocDevice] = useState(false);



  // checks if there is a truck being edited and waits for all data to be loaded


  useEffect(() => {
    //console.log(truckToEdit);
    changeServiceProvider = false;
    trcukDetails = null;
    deviceId = "";
    deviceName = "";
    truckId = "";
    if(truckToEdit){
      //console.log(truckToEdit.truckId);
      truckId = truckToEdit.truckId;
      getDetails();
    }else{
      getAllData();
    }
  }, []);//truckToEdit, segments, providers, types, applications, trucks

  const getDetails = async () => {
    setIsLoading(true);
    let data = await getTruckDetails(truckToEdit.truckId);
    console.log(data);
    //console.log(truckToEdit);
    //defaultTruck = data;
    trcukDetails = data;
    setTruck(data);
    deviceId = data.iotDeviceId;
    deviceName = truckToEdit.deviceId;
    setTimeout(()=>{
      //setTruck(data);
      getAllData();

      //getWareHouseList(data.segmentId);
     // getDevices(data.segmentId,data.serviceProviderId);

      setTruckSize(data.size);
      setTruckBodyMake(data.bodyMake);
      setTruckBodyModel(data.bodyModel);
      setChasisMake(data.chassisMake);
      setChasisModel(data.chassisModel);
      setTrackId(data.truckName);
      setTrackIdErr(data.truckName?false:true);
      //setStatus(null);
      setStatus({key:data.truckStatus,value:data.truckStatus});
      setStatusError(data.truckStatus?false:true);
      setTruckType({label:data.truckType});
      setTruckTypeError(data.truckType?false:true);
      setServiceType({label:data.serviceType});
      setServiceTypeError(data.serviceType?false:true);
      setCurrentServiceProvider({id:data.serviceProviderId,name:truckToEdit.serviceProviderNme});
      setCurrentServiceProviderError(data.serviceProviderId?false:true);
      setCurrentSegment({id:data.segmentId,name:truckToEdit.segmentName});
      setCurrentSegmentError(data.segmentId?false:true);
      setCurrentWareHouse({id:trcukDetails.warehouseLocationId,name:truckToEdit.warehouseLocationNAme});
      setCurrentWareHouseError(trcukDetails.warehouseLocationId?false:true);
      setTimeZone({value: data.timeZone});
      setTimeZoneErr(data.timeZone?false:true);
      setFuelType({label:data.fuelType});
      getSegmentList(data.serviceProviderId);
      if(deviceId){
        setSelectedDevice({id:data.iotDeviceId,name:truckToEdit.deviceId});
      } else {
        setSelectedDevice(null);
      }
      setIsLoading(false);
    },1000);
  }

  const getDeviceTypes = async (sg1: string, sp1: string) => {
    let data = await getAllDeviceTypes();
    console.log(data);
    if (data?.response?.data?.errorMessage) {
      setError(data.response.data.errorMessage);
      return
    }
    // if (data && data[0]) {
    setTypes(data);
    if (!truckToEdit) {
      setTruck(prevtruck => {
        return {
          ...prevtruck,
          truckType: data[0].deviceTypeName
        };
      })
      //  }
    }
  }

  const getTruckTypes = async () => {
    let data = await getTruckAllTypes();
    console.log(data);
    if (data?.response?.data?.errorMessage) {
      setError(data.response.data.errorMessage);
      return
    }
    // if (data && data[0]) {
    let typesArray: any = [];
    let obj: any = {};
    data.forEach((item: any, idx: any) => {
      obj = {};
      obj.label = item;
      typesArray.push(obj);
    });
    setTypes(typesArray);
    // }
  }

  const getServiceTypes = async () => {
    let data = await getTruckAllServiceTypes();
    console.log(data);
    if (data?.response?.data?.errorMessage) {
      setError(data.response.data.errorMessage);
      return
    }
    //if (data && data[0]) {
    let serviceTypesArray: any = [];
    let obj: any = {};
    data.forEach((item: any, idx: any) => {
      obj = {};
      obj.label = item;
      serviceTypesArray.push(obj);
    });
    setServiceTypes(serviceTypesArray);
    //}
  }

  const getFuelTypes = async () => {
    let data = await getTruckAllFuelTypes();
    console.log(data);
    if (data?.response?.data?.errorMessage) {
      setError(data.response.data.errorMessage);
      return
    }
    //if (data && data[0]) {
    let fTypeArray: any = [];
    let obj: any = {};
    data.forEach((item: any, idx: any) => {
      obj = {};
      obj.label = item;
      fTypeArray.push(obj);
    });
    setFuelTypes(fTypeArray);
    // }
  }

  const getServiceProviders = async () => {
    if (truckToEdit) {
      defaultTruck = trcukDetails;
    }

    let data = await getAllServiceProviders();
    if (data?.response?.data?.errorMessage) {
      setError(data.response.data.errorMessage);
      return
    }
    setProviders(data);
  }

  const getUniqueApplicationNames = (objects: any) => {
    const uniqueNames: any = [];
    for (const obj of objects) {
      if (obj.hasOwnProperty('applicationName') && !uniqueNames.includes(obj.applicationName)) {
        uniqueNames.push(obj.applicationName);
      }
    }
    return uniqueNames;
  }

  const getRoles = async () => {
    let data = await getAllRoles();
    if (data?.response?.data?.errorMessage) {
      setError(data.response.data.errorMessage);
      return
    }
    let filtered = getUniqueApplicationNames(data);
    setApplications(filtered);
  }

  const getTrucks = async () => {
    let data = await getAllTrucks();
    if (data?.response?.data?.errorMessage) {
      setError(data.response.data.errorMessage);
      return
    }
    setTrucks(data);
  }

  const getDevices = async (sg1: string, sp1: string) => {
    let data = await getAvailableDevices(sg1, sp1);
    if (data?.response?.data?.errorMessage) {
      setError(data.response.data.errorMessage);
      return
    }
    if(truckToEdit && deviceId){
      data.push({id:deviceId,name:deviceName});
      setSelectedDevice({id:deviceId,name:deviceName});
    }
    setDevices(data);
  }

  const onChangeDevice = (e: any) => {
    setSelectedDevice(e);
  }

  const getAllData = () => {
    setIsLoading(true);
    Promise.all([getServiceProviders(), getRoles(), getTrucks(), getTruckTypes(), getServiceTypes(), getFuelTypes()]);
    setIsLoading(false);
  }

  const getWareHouseList = async (id: string) => {
    let data = await getWareHouses(id);

    if (data?.response?.data?.error) {
      setSegmentError("No Segment found with Service provider");
      return
    }
    setWarehouses(data);
  }

  // calls api for list of segments based on service provider id
  const getSegmentList = async (id: string) => {
    let data = await getSegment(id);
    if (data?.response?.data?.error) {
      setSegmentError("No Segment found with Service provider");
      return
    }
    setWarehouses([]);
    setCurrentWareHouse(null);
    if (data) {
      setSegments(data);
      if(trcukDetails){
          getWareHouseList(trcukDetails.segmentId);
           getDevices(trcukDetails.segmentId,trcukDetails.serviceProviderId);
          setCurrentWareHouse({id:trcukDetails.warehouseLocationId,name:truckToEdit.warehouseLocationNAme});
          setSelectedDevice({id:trcukDetails.iotDeviceId,name:truckToEdit.deviceId});
      }
    }
  }



  const returnInput = (params: InputType) => {
    let { type, placeholder, disabled, label, value, key, required,error,onChange } = params;
    return (
      <Grid item xs={params.size}>
        <TextField style={{width:"100%",paddingBottom:"0px"}}  id="outlined-required" label={placeholder}  value={value}
                   onChange={(e) => onChange(e.target.value)} required={required} error={error} />
      </Grid>
    )
  }

  const handleInputChange = (val: any, key: string) => {
    setTruck({ ...truck, [key]: val })
  };

  const handleConfigDevices = (val: any, key: string) => {
    setTruck({ ...truck, [key]: val })
  };

  const onChangeServiceProvider = (e: any) => {
    trcukDetails = null;
    //let z = e.value1;
    setWarehouses([]);
    setCurrentSegment(null);
    setCurrentSegmentError(true);
    setTimeZoneErr(true);
    setCurrentWareHouse(null);
    //setDevices([]);
    setSegments([]);
    setCurrentServiceProvider(e);
    if (e) {
      //console.log(e.value1);
      if (e.value1 !== "" || e.value1 !== null) {
        setTimeZone({ key: e.value1, value: e.value1 });
        setTimeZoneErr(false);
      }
      if (e.value1 === "" || e.value1 === null) {
        setTimeZone({ key: e.value1, value: e.value1 });
        setTimeZoneErr(true);
      }
      setCurrentServiceProviderError(false);
      getSegmentList(e.id);
      if(truckToEdit && deviceId){
        let data: { id: string, name: string }[] = [
          { id: deviceId, name: deviceName }
      ];
        setDevices(data);
        setSelectedDevice({id:deviceId,name:deviceName});
      }
    } else {
      setCurrentServiceProviderError(true);
      setTimeZoneErr(true);
    }
    setPage(Math.random() * 10000);
  }

  const onChangeSegment = (e:any)=>{
    trcukDetails = null;
    setCurrentWareHouse(null);
    setCurrentWareHouseError(true);
    setCurrentSegment(e);
    if(e){
      getWareHouseList(e.id);
      if(currentServiceProvider){
        getDevices(e.id,currentServiceProvider.id);
      }
      setCurrentSegmentError(false);
    }else{
      setCurrentSegmentError(true);
    }
  }

  let onChangeWarehouseLoc = (data:any)=>{
    setCurrentWareHouse(data);
    if(data){
      setCurrentWareHouseError(false);
    }else{
      setCurrentWareHouseError(true);
    }
  }

 let onChangeTimeZone = (data:any) => {
  setTimeZone(data);
  if(data){
    setTimeZoneErr(false);
  }else{
    setTimeZoneErr(true);
  }
 }

  const getWarehouseIdByName = (sName:string)=>{
    //console.log(providers);
    for(let i=0;i<warehouses.length;i++){
      if(warehouses[i].name == sName){
        return warehouses[i].id;
      }
    }
    return "";
  }

  const getServiceProviderIdByName = (sName:string)=>{
    //console.log(providers);
    for(let i=0;i<providers.length;i++){
      if(providers[i].name == sName){
        return providers[i].id;
      }
    }
    return "";
  }
  const getSegmentIdByName = (sName:string)=>{
    //console.log(providers);
    for(let i=0;i<segments.length;i++){
      if(segments[i].name == sName){
        return segments[i].id;
      }
    }
    return "";
  }

  let getRequestObject = ():any=>{
    if(!trackId){
      setTruckTypeError(true);
    }
    if(!status){
      setStatusError(true);
    }
    if(!truckType){
      setTruckTypeError(true);
    }
    if(!serviceType){
      setServiceTypeError(true);
    }
    if(!currentServiceProvider){
      setCurrentServiceProviderError(true);
    }
    if(!currentSegment){
      setCurrentSegmentError(true);
    }
    if(!currentWarehouse){
      setCurrentWareHouseError(true);
    }
    if(!timeZone){
      setTimeZoneErr(true);
    }
    
    if(trackId && status && truckType && serviceType && currentServiceProvider && currentSegment && currentWarehouse && timeZone){
      let reqObj:any = {};
      reqObj.truckName = trackId;
      reqObj.truckStatus = status?status.value:"";
      reqObj.truckType = truckType?truckType.label:"";
      reqObj.warehouseLocation = currentWarehouse?currentWarehouse.name:"";
      reqObj.warehouseLocationId = currentWarehouse?currentWarehouse.id:"";
      reqObj.timeZone = timeZone?timeZone.value:"";
      reqObj.size = truckSize;//?truckSize.id:"";;;
      reqObj.serviceType = serviceType?serviceType.label:"";
      reqObj.serviceTypeId = serviceType?serviceType.id:"";;
      reqObj.serviceProvider = currentServiceProvider?currentServiceProvider.name:"";
      reqObj.serviceProviderId = currentServiceProvider?currentServiceProvider.id:"";;
      reqObj.segmentId = currentSegment?currentSegment.id:"";
      reqObj.segment = currentSegment?currentSegment.name:"";;
      reqObj.iotDeviceId = currentDevice?currentDevice.id:"";
      reqObj.fuelType = fuelType?fuelType.label:"";
      reqObj.chassisModel = chasisModel;
      reqObj.chassisMake = chasisMake;
      reqObj.bodyModel = truckBodyModel;
      reqObj.bodyMake = truckBodyMake;
      reqObj.deviceName = "";
      return reqObj;
    }
    return null;

  }

  let handleDeleteTruck = async (truck:any) => {
    let data = await deleteTruck(truck.truckId);
    if (data?.response?.data?.errorMessage) {
      //setError(data.response.data.errorMessage);
      ToastManager.showToast(data.response.data.errorMessage,"Error");
      return;
    }
    if (data) {
      ToastManager.showToast("Truck Deleted Successfully","Success");
      handleClose(false);
      getTruckList();
    }
  }
  const handleAddTruck = async () => {
    let reqObj:any = getRequestObject();
    console.log(reqObj);
    if(reqObj){
      let data = await addTruck(reqObj);
      if (data?.response?.data?.errorMessage) {
        ToastManager.showToast(data?.response?.data?.errorMessage,"Error");
        //setError(data.response.data.errorMessage);
        return;
      }
      if (data) {
        ToastManager.showToast("Truck Created Successfully","Success");
        handleClose(false);
        getTruckList();
      }
    }



    /*setError("");
    if(truck.truckName === "") {
      setError("truck Name is required");
    } else {
      console.log(truck)
      let data = await addTruck(truck);
      if (data?.response?.data?.errorMessage) {
        setError(data.response.data.errorMessage);
        return;
      }
      if (data) {
        handleClose(false);
        getTruckList();
      }
    }*/
  }

  const handleEditTrcuk = async () => {
    /*if(truck.truckName === "") {
      setError("truck Name is required");
    } else {
      let data = await editTruck(truck);
      if (data?.response?.data?.errorMessage) {
        setError(data.response.data.errorMessage);
        return;
      }
      if (data) {
        handleClose(false);
        getTruckList();
      }
    }*/
    let reqObj:any = getRequestObject();
    reqObj.truckId = truckToEdit.truckId
    console.log(reqObj);
    if(reqObj){
      let data = await editTruck(reqObj);
      if (data?.response?.data?.errorMessage) {
        ToastManager.showToast(data?.response?.data?.errorMessage,"Error");
        //setError(data.response.data.errorMessage);
        return;
      }
      if (data) {
        ToastManager.showToast("Truck Updated Successfully","Success");
        handleClose(false);
        getTruckList();
      }
    }

  }

  const handleTypeChange = (val: string) => {
    let filtered: any = types.filter((t: any) => t.deviceTypeName === val);
    if (filtered.length > 0) {
      //setTruck({ ...truck, deviceTypeName: val, truckTypeId: filtered[0].truckTypeId });
    }
  }

  const handleTruckName = (val: string) => {
    let filtered = trucks.filter((t: any) => t.truckName === val);
    if(filtered.length > 0) {
      setCurrentTruckName(val);
      setTruck({...truck, truckName: filtered[0].truckName});
    }
  }

  let onClickDeviceDisassociate = async ()=>{
    setDisassocDevice(true);
  }

  let handleDisassocDevice = ()=>{
    setDisassocDevice(false);
  }

  let onClickTruckDisassoc = ()=>{
    setDisassocDevice(true);
  }
  let closeDisassociationModal = ()=>{
    setDeviceDisassociation(false);
  }

  let onChangeStatus = (data:any)=>{
    setStatus(data);
    if(data){
      setStatusError(false);
    }else{
      setStatusError(true);
    }

  }

  let onChangeTruckTypes = (data:any)=>{
    setTruckType(data);
    if(data){
      setTruckTypeError(false);
    }else{
      setTruckTypeError(true);
    }
  }

  let onChangeServiceType = (data:any)=>{
    setServiceType(data);
    if(data){
      setServiceTypeError(false);
    }else{
      setServiceTypeError(true);
    }
  }



  let onChangeTrackId = (e:any)=>{
    //console.log(e);
    setTrackId(e);
    if(e == ""){
      setTrackIdErr(true);
    }else{
      setTrackIdErr(false);
    }
  }

  let onChangeBodyModel = (e:any)=>{
    setTruckBodyModel(e);
  }

  let onChangeBodyMake = (e:any)=>{
    setTruckBodyMake(e);
  }

  let onChangeChasisModel = (e:any)=>{
    setChasisModel(e);
  }

  let onChangeChasisMake = (e:any)=>{
    setChasisMake(e);
  }

  let onChangeTruckSize = (e:any)=>{
    var value = parseInt(e, 10);
    if (value > 999) value = 999;
    if (value < 0) value = 0;
    setTruckSize(''+value);
  }

  let setDeleteTruck = ()=>{
    setDelDevice(false);
  }

  let getList = ()=>{

  }
  let handleOnDeleteTruck = ()=>{
    setDelDevice(true);
  }

  let handleDisassociationDevice = async(truck:any)=>{
    console.log(truck);
    if(truck.truckId && truck.iotDeviceId){
      let data = await deviceDisassoc(truck.truckId,truck.iotDeviceId);
      if (data?.response?.data?.errorMessage) {
        ToastManager.showToast(data.response.data.errorMessage,"Error");
        return;
      }
      if (data) {
        handleClose(false);
        getTruckList();
        ToastManager.showToast("Truck Disassociated Successfully","Success");
      }
    }
  }


  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <>
        {delDevice && <DeleteModal title={"Delete Truck"} open={delDevice} handleDelete={handleDeleteTruck} handlePopupClose={setDeleteTruck} role={truckToEdit} getList={getList} />}
        {disassocDevice && <DisAssocModal title={"Truck Association"} open={disassocDevice} handleDelete={handleDisassociationDevice} handlePopupClose={handleDisassocDevice} role={truckToEdit} getList={getList} />}

        <Box sx={styles.container}>
          {isLoading && <LinearProgress sx={{ margin: ".5rem 0" }} />}
          {error !== "" && <Typography sx={{ color: "red", fontSize: ".7rem" }}>{error}</Typography>}
          <Grid item xs={12} sx={styles.header}>
            <h2>{truckToEdit !== null ? "Edit Truck" : "Add Truck"}</h2>
            <CloseIcon onClick={() => handleClose(false)} />
          </Grid>

          <Grid container spacing={5}>
            <Grid item xs={12} className="truckContainer" >
              <Typography sx={styles.subHeader} style={{marginTop:"0px",fontWeight:"bold"}}>Truck Information</Typography>
              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={6}>
                  <TextField style={{width:"100%",paddingBottom:"0px"}} inputProps={{ maxLength: 30 }} label={"Truck Number"}  value={trackId}
                             onChange={(e) => onChangeTrackId(e.target.value)} required={true} error={trackIdErr} />
                </Grid>
                {/*returnInput({ type: "input", placeholder: "Truck Id", size: 6, key: "truckName",required:true,error:{trackIdErr}, value: trackId, onChange: onChangeTrackId })*/}
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                   <TruckMuiSelect label={"Status"} sKey={"key"} value={"value"} selectedValue={status} dataSource={truckStatuses}
                                   mandatory={true} iserror={statusError} onChangeHandler={(e: any) => onChangeStatus(e)} disabled={truckToEdit!=null?false:true} />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Truck Type"} sKey={"label"} value={"label"} dataSource={types} selectedValue={truckType} mandatory={true} iserror={truckTypeError}
                                  onChangeHandler={(e: any) => onChangeTruckTypes(e)}/>
                </Grid>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Service Type"} sKey={"label"} value={"label"}  dataSource={serviceTypes} selectedValue={serviceType} mandatory={true} iserror={serviceTypeError}
                                  onChangeHandler={(e: any) => onChangeServiceType(e)} />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Service Provider Name"} sKey={"id"} value={"name"} selectedValue={currentServiceProvider} dataSource={providers} mandatory={true} iserror={currentServiceProviderError}
                                  onChangeHandler={(e: any) => onChangeServiceProvider(e)} />
                  {segmentError !== "" && <Typography sx={{ color: "red", fontSize: ".7rem" }}>{segmentError}</Typography>}
                </Grid>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Segment Name"} sKey={"id"} value={"name"} selectedValue={currentSegment} dataSource={segments} mandatory={true} iserror={currentSegmentError}
                                  onChangeHandler={(e: any) => onChangeSegment(e)} />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Warehouse Location"} sKey={"id"} value={"name"} selectedValue={currentWarehouse} dataSource={warehouses} mandatory={true} iserror={currentWarehouseError}
                                  onChangeHandler={(e: any) => onChangeWarehouseLoc(e)} />
                </Grid>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Timezone"} sKey={"key"} value={"value"} selectedValue={timeZone} dataSource={timeZones} mandatory={true} iserror={timeZoneErr}
                                  onChangeHandler={(e: any) => onChangeTimeZone(e)} />
                </Grid>
                <Grid item xs={6}>
                  <TextField style={{width:"100%",paddingBottom:"0px"}}  inputProps={{ maxLength: 40 }} label={"Body - Make"}  value={truckBodyMake}
                             onChange={(e) => onChangeBodyMake(e.target.value)} required={false} error={false} />
                </Grid>
                {/*returnInput({ type: "input", placeholder: "Body - Make", size: 6, key: "bodyMake", value: truck.bodyMake, onChange: handleInputChange })*/}
                <Grid item xs={6}>
                  <TextField style={{width:"100%",paddingBottom:"0px"}}   inputProps={{ maxLength: 40 }} label={"Body - Model"}  value={truckBodyModel}
                             onChange={(e) => onChangeBodyModel(e.target.value)} required={false} error={false} />
                </Grid>
                <Grid item xs={6}>
                  <TextField style={{width:"100%",paddingBottom:"0px"}}   inputProps={{ maxLength: 40 }} label={"Chassis - Make"}  value={chasisMake}
                             onChange={(e) => onChangeChasisMake(e.target.value)} required={false} error={false} />
                </Grid>

                {/*returnInput({ type: "input", placeholder: "Body - Model", size: 6, key: "bodyModel", value: truck.bodyModel, onChange: handleInputChange })*/}
                {/*returnInput({ type: "input", placeholder: "Chassis - Make", size: 6, key: "chassisMake", value: truck.chassisMake, onChange: handleInputChange })*/}
              
                <Grid item xs={6}>
                  <TextField style={{width:"100%",paddingBottom:"0px"}}   inputProps={{ maxLength: 40 }} label={"Chassis - Model"}  value={chasisModel}
                             onChange={(e) => onChangeChasisModel(e.target.value)} required={false} error={false} />
                </Grid>
                <Grid item xs={6}>
                  <TextField style={{width:"100%",paddingBottom:"0px"}} InputProps={{inputProps: { maxLength: 3, max: 999, min: 0 }}} label={"Size"}  value={truckSize} type={"number"}
                             onChange={(e) => onChangeTruckSize(e.target.value)} required={false} error={false} />
                </Grid>
                {/*returnInput({ type: "input", placeholder: "Chassis - Model", size: 6, key: "chassisModel", value: truck.chassisModel, onChange: handleInputChange })*/}
                {/*returnInput({ type: "input", placeholder: "Size", size: 6, key: "size", value: truck.size, onChange: handleInputChange })*/}
             
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Fuel Type"} sKey={"label"} value={"label"} selectedValue={fuelType} dataSource={fuelTypes} mandatory={false} iserror={false}
                                  onChangeHandler={(e: any) => setFuelType(e)} />
                </Grid>

              </Grid>

            </Grid>

             <Grid item xs={12} className="truckContainer">
                <Typography sx={styles.subHeader} style={{marginTop:"0px",fontWeight:"bold"}}>Associate/Disassociate Device</Typography>
                <Grid container spacing={2} sx={styles.subContainer}>
                  <Grid item xs={6}>
                    <TruckMuiSelect label={"Device Id"} sKey={"id"} value={"name"} selectedValue={currentDevice} dataSource={devices}
                                    onChangeHandler={(e: any) => onChangeDevice(e)} mandatory={false} iserror={false} />
                  </Grid>
                  <Grid item xs={6}>
                    { (truckToEdit!=null && truckToEdit.iotDeviceId)?<Button sx={styles.addButton} onClick={onClickDeviceDisassociate}>Disassociate</Button>:"" }
                  </Grid>
                </Grid>
              </Grid>


          </Grid>

          <Grid item xs={12} sx={styles.buttonContainer}>
            <Button sx={styles.cancelButton} onClick={() => handleClose(false)}>Cancel</Button>
            {(truckToEdit !== null && CommonUtil.isScreenButtonAvailable(CommonUtil.TRUCK_MANAGER,CommonUtil.UPDATE_MODE))? <Button sx={styles.deleteButton} onClick={handleOnDeleteTruck}>{"Delete"}</Button>:""}
            {(truckToEdit !== null && CommonUtil.isScreenButtonAvailable(CommonUtil.TRUCK_MANAGER,CommonUtil.UPDATE_MODE))?<Button sx={styles.addButton} onClick={handleEditTrcuk}>{"Update" }</Button>:""}
            {(!truckToEdit && CommonUtil.isScreenButtonAvailable(CommonUtil.TRUCK_MANAGER,CommonUtil.UPDATE_MODE))?<Button sx={styles.addButton} onClick={handleAddTruck}>{"Save"}</Button>:""}
          </Grid>
        </Box>
      </>
    </Modal>
  )
}

export default TruckModal;
